<template>
	<div class="order-result">
		<img src="../../../assets/img-v2/ic_order_result.png" class="icon" />
		<div>
			<div class="title">非常遗憾</div>
			<div class="desc">预付车费我们会在3个工作日内原路返还至您的支付账户中，感谢使用</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'orderResult'
};
</script>

<style scoped lang="scss">
.order-result {
	border-radius: 12px;
	background: radial-gradient( 111% 115% at 29% 9%, #F0F7FF 0%, #BBDBFF 50%, #FFFFFF 100%);
	padding: 20px 14px 30px 14px;
	transform: translateY(10px);
	display: flex;
	align-items: center;
	.icon {
		width: 44px;
		height: 44px;
		min-width: 44px;
		margin-right: 12px;
	}
	.title {
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 18px;
		color: #000000;
		line-height: 25px;
	}
	.desc {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: rgba(0,0,0,0.7);
		line-height: 20px;
		margin-top: 4px;
	}
}
</style>
